import './SliderUiObject.scss';
import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { usePostHog } from 'posthog-js/react';
import { max, min } from 'lodash';
import Typography from '@mui/material/Typography';

import NumberSelector from '../common/ui/NumberSelector';
import { useLanguage } from '../common/GeneralUtils';

const SliderUiObject = (props) => {
  const posthog = usePostHog();
  const { uiObject, orderState, setOrderDetailValue, type, isLoadingDates } = props;

  const language = useLanguage();
  const shouldLimitSliderMax = !!orderState.specificEvent;

  const [sliderValue, setSliderValue] = useState(max([orderState.details[uiObject.data_type], uiObject.min_value]));
  let minValue = type === 'edit' ? 1 : uiObject.min_value;
  // to allow admins create bookings for even one participant
  let maxValue = shouldLimitSliderMax
    ? min([orderState.specificEvent?.tickets_left, uiObject.max_value])
    : uiObject.max_value;

  const onSliderCommit = (val) => {
    posthog.startSessionRecording({});
    setOrderDetailValue(uiObject.data_type, val);
  };

  if (type === 'edit' && uiObject.dashboardNoLimit) {
    minValue = 1;
    maxValue = 100;
  }
  const sliderText = uiObject.label[language];
  return (
    <Grid container flexDirection="column">
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="body1">{sliderText}</Typography>
        </Grid>
        <Grid>
          <NumberSelector
            value={sliderValue}
            setValue={(val) => {
              setSliderValue(val);
              onSliderCommit(val);
            }}
            disabled={minValue === maxValue || isLoadingDates}
            min={minValue}
            max={maxValue}
          />
        </Grid>
      </Grid>
      {uiObject.post_label && (
        <div className="text-label" dangerouslySetInnerHTML={{ __html: uiObject.post_label[language] }} />
      )}
    </Grid>
  );
};

export default SliderUiObject;
